import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
  Fade,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import CloseIcon from '@material-ui/icons/Close';



export interface ModalProps {
  aberto?: boolean;
  children?: ReactNode;
  carregando?: ReactNode;
  titulo?: string;
  tamanho?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  quandoForFechado?: () => any;
}

const useStyles = makeStyles((theme) => ({
  content: {
    padding: '15px',
    [theme.breakpoints.down('xs')]: {
      padding: '7px',
    },
  },
  titulo: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  loading: {
    paddingTop: '250px',
    paddingBottom: '250px',
    display: 'flex',
    justifyContent: 'center',
    background: 'transparent',
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Fade timeout={500} ref={ref} {...props} />;
});

export const Modal = ({
  aberto,
  children,
  carregando,
  titulo,
  tamanho,
  quandoForFechado,
}: ModalProps) => {
  const classes = useStyles();

  return (
    <Dialog
      maxWidth={tamanho || 'lg'}
      open={aberto || false}
      fullWidth
      keepMounted
      disableEscapeKeyDown
      TransitionComponent={Transition}
    >
      <DialogTitle disableTypography className={classes.titulo}>
        <Typography variant="h6">
          <strong>{titulo}</strong>
        </Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={quandoForFechado}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {carregando}
    </Dialog>
  );
};
